// Pre-fetched gallery images for each service
export const galleryImages = {
  'shower-doors': [
    '/images/showers/showers_1.webp',
    '/images/showers/showers_2.webp',
    '/images/showers/showers_3.webp',
    '/images/showers/showers_4.webp',
    '/images/showers/showers_5.webp',
    '/images/showers/showers_6.webp',
    '/images/showers/showers_7.webp',
    '/images/showers/showers_8.webp',
    '/images/showers/showers_9.webp',
  ],
  'mirrors': [
    '/images/studio-mirrors/studio-mirrors_1.webp',
    '/images/studio-mirrors/studio-mirrors_2.webp',
    '/images/studio-mirrors/studio-mirrors_3.webp',
    '/images/studio-mirrors/studio-mirrors_4.webp',
    '/images/studio-mirrors/studio-mirrors_5.webp',
    '/images/studio-mirrors/studio-mirrors_6.webp',
    '/images/studio-mirrors/studio-mirrors_7.webp',
    '/images/studio-mirrors/studio-mirrors_8.webp',
    '/images/studio-mirrors/studio-mirrors_9.webp',
  ],
  'glass-railings': [
    '/images/glass-railings/glass-railings_1.webp',
    '/images/glass-railings/glass-railings_2.webp',
    '/images/glass-railings/glass-railings_3.webp',
    '/images/glass-railings/glass-railings_4.webp',
    '/images/glass-railings/glass-railings_5.webp',
    '/images/glass-railings/glass-railings_6.webp',
    '/images/glass-railings/glass-railings_7.webp',
    '/images/glass-railings/glass-railings_8.webp',
    '/images/glass-railings/glass-railings_9.webp',
  ],
  'glass-tabletops-shelves': [
    '/images/table-tops/table-tops_1.webp',
    '/images/table-tops/table-tops_2.webp',
    '/images/table-tops/table-tops_3.webp',
    '/images/table-tops/table-tops_4.webp',
    '/images/table-tops/table-tops_5.webp',
    '/images/table-tops/table-tops_6.webp',
    '/images/table-tops/table-tops_7.webp',
    '/images/table-tops/table-tops_8.webp',
    '/images/table-tops/table-tops_9.webp',
  ],
  'storefronts': [
    '/images/storefront/storefront_1.webp',
    '/images/storefront/storefront_2.webp',
    '/images/storefront/storefront_3.webp',
    '/images/storefront/storefront_4.webp',
    '/images/storefront/storefront_5.webp',
    '/images/storefront/storefront_6.webp',
    '/images/storefront/storefront_7.webp',
    '/images/storefront/storefront_8.webp',
    '/images/storefront/storefront_9.webp',
  ],
};

export const heroImages = {
  'shower-doors': '/images/hero-shower-doors.webp',
  'mirrors': '/images/hero-dance-studio-mirror.webp',
  'glass-railings': '/images/hero-glass-railings.webp',
  'glass-tabletops-shelves': '/images/hero-table-top-glass.webp',
  'storefronts': '/images/hero-storefronts.webp',
};

export const beforeAfterImages = {
  'shower-doors': {
    before: '/images/before-after/shower-before.jpg',
    after: '/images/before-after/shower-after.jpg',
  },
  'mirrors': {
    before: '/images/before-after/mirror-before.jpg',
    after: '/images/before-after/mirror-after.jpg',
  },
  'glass-railings': {
    before: '/images/before-after/railings-before.jpg',
    after: '/images/before-after/railings-after.jpg',
  },
  'glass-tabletops-shelves': {
    before: '/images/before-after/tabletop-before.jpg',
    after: '/images/before-after/tabletop-after.jpg',
  },
  'storefronts': {
    before: '/images/before-after/storefront-before.jpg',
    after: '/images/before-after/storefront-after.jpg',
  },
};
